<citadel-app-frame [layout]="'open'" [showSidebar]="false">

  <ng-container app-content>

    <router-outlet />






  </ng-container>

  <ng-container app-footer>

    @if(description !== '' && description !== null) {
    <div class="footer-banner">
      <div class="icon">
        <citadel-icon [icon]="'help-circle'" [size]="32" [color]="'alternate-1'" />
      </div>
      <div>
        <!-- <p><strong>We are a phone call away if you need any technical support.</strong></p>
        <p>
          Contact us on <a class="teal" href="tel:+27 86 110 0628">+27 86 110 0628</a> between 08:00 and 16:30 on weekdays, or email <span class="teal">{{emailStr}}</span>
        </p> -->



        <span><strong>{{ description }}</strong> </span>

        @if (contactDescriptionBefore !== ''){
        <br />
        <span>{{contactDescriptionBefore}}</span>
        }
        @if(phoneNumber !== ''){
        <span class="teal"><a [href]="'tel:' + phoneNumber">{{ phoneNumber }}</a></span>
        }
        @if (contactDescriptionAfter !== ''){
        <span>{{contactDescriptionAfter}}</span>
        }
        @if(email !== ''){
        <span class="teal"><a [href]="emailObject">{{ email }}</a></span>
        }



      </div>

    </div>
    }


    <div class="footerMainCls">
      <div class="footerCls">
        <citadel-footer class="no-border" [footerItems]="footerItems" />
      </div>
      @if (footerWording !== '' && footerWording !== null) {
      <div class="footerCls footerWordingCls">
        {{footerWording}}
      </div>
      }


    </div>
  </ng-container>


</citadel-app-frame>

<!-- <ng-template #systemNotification>
  <div><citadel-icon icon="bell" /><span>{{notification.heading}}</span></div>
  <div><span>{{notification.text}}</span></div>
</ng-template> -->